import { toDbId } from "~/utils/graphql-helpers";
import { ProfileCreationModal } from "../CaseDetailsDrawer/Profiles/common/AutoProfileCreationCard/ProfileCreationModal";
import { useCaseFormContext } from "./CaseFormContext";

export const InvestorProfileCreationModal = () => {
  const caseFormContext = useCaseFormContext();
  const arenaIdGlobalId = caseFormContext?.caseInformationData?.client?.id;
  const arenaId = arenaIdGlobalId ? toDbId(arenaIdGlobalId) : undefined;
  return <ProfileCreationModal arenaId={arenaId} />;
};
